import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { handleApiError } from "../../utils/handleApiError";

// Fetch Members API
export const fetchMembers = createAsyncThunk(
  "members/fetchMembers",
  async (_, { rejectWithValue }) => {
    const token = localStorage.getItem("userToken");
    const url = `${process.env.REACT_APP_API_URL}admin/v1/get_accepted_invites`;

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 180000); 
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
        signal: controller.signal,
      });

      clearTimeout(timeout);

      const textResponse = await response.text();
      let data;
      try {
        data = JSON.parse(textResponse);
      } catch (parseError) {
        toast.error("Failed to parse JSON response.");
        return rejectWithValue("Failed to parse JSON response.");
      }

      if (response.ok && data.status === 200) {
        
        return data.data || [];
        
      } else {
        const errorMessage =
          data.message ||
          "Once you invite users, it will appear here. Start inviting users now!";
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
      }
    } catch (error) {
      const friendlyMessage = handleApiError(error);
      toast.error(
        friendlyMessage ||
          "Something went wrong while fetching accepted invites."
      );
      return rejectWithValue(friendlyMessage || error.message);
    }
  }
);

const initialState = {
  members: [],
  loading: false,
  error: null,
};

const memberSlice = createSlice({
  name: "members",
  initialState,
  reducers: {
    setMembers(state, action) {
      state.members = action.payload;
    },
    clearMembers(state) {
      state.members = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMembers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.members = action.payload;
      })
      .addCase(fetchMembers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { setMembers, clearMembers } = memberSlice.actions;
export default memberSlice.reducer;
